import HeaderElement from "../../components/HeaderElement/HeaderElement";
import SearchBar from "../../components/MemberManagement/SearchBar/SearchBar";
import HistoryVoteCard from "../../components/Voting/HistoryVoteCard/HistoryVoteCard";
import strings from "../../locales/ro.json";

import React from "react";

import "./VoteHistory.css";

const VoteHistory = () => {
  const [filteredBallots, setFilteredBallots] = React.useState([
    {
      title: "Hear! The Siren Song Call of Death!",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Duel!",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Versus",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "The World Looks White",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "The World Looks Red",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Castle Vein",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "War With No Reason",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Boris",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
  ]);

  //   React.useEffect(() => {
  //     setFilteredBallots(ballots);
  //   }, [ballots]);

  const ballots = [
    {
      title: "Hear! The Siren Song Call of Death!",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Duel!",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Versus",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "The World Looks White",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "The World Looks Red",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Castle Vein",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "War With No Reason",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
    {
      title: "Boris",
      description: "Sunteti de acord ca Boris este cel mai jmecher motan?",
    },
  ];

  const handleFilterChange = (event) => {
    // setFilter(event.target.value);
    setFilteredBallots((prevArr) => {
      let newArr = [];

      newArr = ballots.filter((element) => {
        return element["title"]
          .toLowerCase()
          .includes(event.target.value.toLowerCase());
      });
      console.log(newArr);
      return newArr;
    });
  };

  return (
    <div className="voteHistoryPageWrapper">
      <div className="voteHistoryGrid">
        <HeaderElement headerText={strings.voteHistory.title} />
        <div className="historySearch">
          <SearchBar handleChange={handleFilterChange} />
        </div>
        <div className="voteCardWrapper">
          {/* <HistoryVoteCard title='Hear! The Siren Song Call of Death' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='The World Looks Red' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='The World Looks White' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='War With No Reason' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='Castle Vein' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='Duel' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='Versus (Duel Reprise)' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/>
                    <HistoryVoteCard title='Boris' description="Sunteti de acord ca Boris este cel mai jmecher motan?"/> */}
          {filteredBallots.map((ballot) => {
            return (
              <HistoryVoteCard
                title={ballot.title}
                description={ballot.description}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VoteHistory;
